<template>
  <div>
    <!-- <div class="block_progress form_wrapper">
      <div class="form_header">
        <div class="form_header_name">流程进度</div>
        <div class="form_header_remarks"></div>
      </div>
      <div class="stepsblock">
        <el-steps
          :active="data.process"
          :space="'100%'"
          align-center
          :center="true"
        >
          <el-step
            title="新增子基金"
            :description="moment(data.createTime).format('YYYY-MM-DD HH:mm')"
          ></el-step>

          <el-step
            title="提交审核"
            :description="data.submitTime != '' ? data.submitTime : '等待审核'"
          ></el-step>
          <el-step
            title="审核中"
            :description="
              data.auditBeginTime != '' ? data.auditBeginTime : '等待审核'
            "
          ></el-step>

          <el-step
            :title="data.auditState == 2 ? '审核通过' : '审核结果'"
            :description="data.auditTime != '' ? data.auditTime : '等待审核'"
          >
            <template slot="title">
              {{ data.auditState == 2 ? "审核通过" : "审核结果" }}
              <span v-if="data.auditLog && data.auditState >= 2"
                ><i
                  class="el-icon-warning-outline warningblock"
                  @click="warningblock"
                ></i
              ></span>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div> -->

    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <!-- 融资租赁 -->
          <div>
            <div class="form_wrapper">
              <div class="form_header">
                <div class="form_header_name">基金信息</div>
                <div class="form_header_remarks"></div>
              </div>
              <div class="form_content">
                <div class="label_name">基本信息</div>
                <div class="bankcontent">
                  <Detaillist :detaillist="detaillist" :data="data" />
                </div>
                <div class="label_name">财务信息</div>
                <div class="bankcontent">
                  <Detaillist :detaillist="detaillistFinance" :data="data" />
                </div>
                <div class="label_name">基金管理人</div>
                <div class="bankcontent">
                  <Detaillist :detaillist="detaillistManage" :data="data" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accessory from "@/components/accessories/accessory";
import Detaillist from "@/components/detail/contract_currency/detaillist";
import moment from "moment";

export default {
  name: "",
  data() {
    return {
      // 基本信息
      detaillist: {
        column: [
          {
            label: "基金名称",
            prop: "name",
          },
          {
            label: "设立时间",
            prop: "establishmentTime",
          },
          {
            label: "母基金",
            prop: "masterName",
            url: "/fund/masterfund/detail/",
            urlId: "masterId",
            // dicUrl: "/api/blade-system/dict-biz/dictionary?code=collection_type",
          },
          {
            label: "合作方式",
            prop: "cooperateType",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
          },
          {
            label: "投后报告周期",
            prop: "manageCycle",
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
          },
          {
            label: "基金状态",
            prop: "fundState",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_state",
          },
          {
            label: "基金大类",
            prop: "fundTargetType",
            formatter: () => {
              return this.data.fundTargetType == 0? "纾困基金":this.data.fundTargetType == 1?"政府产业基金":'-'
            },
          },          
          {
            label: "基金类型",
            prop: "isDirectional",
            formatter: () => {
              return this.data.isDirectional === 0? "非定向":this.data.isDirectional === 1?"定向":'-'
            },
          },          
          {
            label: "投资期截止日期",
            prop: "investEndDate",
          },
          {
            label: "退出期截止日期",
            prop: "quitEndDate",
          },
        ],
        firstsblock: {
          formatter: () => {
            return 24;
          },
        },
        sentersblock: {
          formatter: () => {
            return 0;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
      },
      // 财务信息
      detaillistFinance: {
        column: [
          {
            label: "管理费收取模式",
            prop: "manageIncomeType",
            style:'width:100%'
          },

          {
            label: "基金认缴规模",
            prop: "peScale",
            formatter: () => {
              return this.data.peScale == -1
                ? "-"
                : this.getMoney(this.data.peScale) + "元";
            },
          },
          {
            label: "基金实缴金额",
            prop: "totalCapitalPaid",
            formatter: () => {
              return this.data.totalCapitalPaid == -1
                ? "-"
                : this.getMoney(this.data.totalCapitalPaid) + "元";
            },
          },
          {
            label: "基金已投金额",
            prop: "allFundAmount",
            formatter: () => {
              return this.data.allFundAmount == -1
                ? "-"
                : this.getMoney(this.data.allFundAmount) + "元";
            },
          },
          {
            label: "已收回金额",
            prop: "fundQuidAmount",
            formatter: () => {
              return this.data.fundQuidAmount == -1
                ? "-"
                : this.getMoney(this.data.fundQuidAmount) + "元";
            },
          },
          {
            label: "政府产业基金认缴额",
            prop: "govIndustrySubscribed",
            formatter: () => {
              return this.data.govIndustrySubscribed == -1
                ? "-"
                : this.getMoney(this.data.govIndustrySubscribed) + "元";
            },
          },
          {
            label: "政府产业基金实缴额",
            prop: "realGovIndustrySubscribed",
            formatter: () => {
              return this.data.realGovIndustrySubscribed == -1
                ? "-"
                : this.getMoney(this.data.realGovIndustrySubscribed) + "元";
            },
          },
          {
            label: "社会资本认缴额",
            prop: "otherCapitalSubscribed",
            formatter: () => {
              return this.data.otherCapitalSubscribed == -1
                ? "-"
                : this.getMoney(this.data.otherCapitalSubscribed) + "元";
            },
          },
          {
            label: "社会资本实缴额",
            prop: "realotherCapitalSubscribed",
            formatter: () => {
              return this.data.realotherCapitalSubscribed == -1
                ? "-"
                : this.getMoney(this.data.realotherCapitalSubscribed) + "元";
            },
          },

          {
            label: "带动社会投资额",
            prop: "allSocietyAmount",
            formatter: () => {
              return this.data.allSocietyAmount == -1
                ? "-"
                : this.getMoney(this.data.allSocietyAmount) + "元";
            },
          },
          {
            label: "政府产业基金出资比例",
            prop: "capitalRatio",
            append:'%'
          },
        ],
        firstsblock: {
          formatter: () => {
            return 24;
          },
        },
        sentersblock: {
          formatter: () => {
            return 0;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
      },
      // 基金管理人
      detaillistManage: {
        column: [
          {
            label: "基金管理人名称",
            prop: "manager.name",
          },
          {
            label: "基金协会编码",
            prop: "manager.orgCode",
          },
          {
            label: "所在地区",
            prop: "manager.region",
            // formatter: () => {
            //   return (this.data.manager.region?this.data.manager.region.replaceAll(",",""):'') + this.data.manager.address;
            // },
          },
          {
            label: "所在地址",
            prop: "manager.address",
            
          },
          
          {
            label: "成立时间",
            prop: "manager.establishmentTime",
          },
          {
            label: "纳税识别号",
            prop: "manager.creditCode",
          },
          // {
          //   label: "所在地址",
          //   prop: "provinceName",
          //   formatter: () => {
          //     return (this.data.manager.region?this.data.manager.region.replaceAll(",",""):'') + this.data.manager.address;
          //   },
          // },
          
          
          {
            label: "联系人",
            prop: "manager.contactPerson",
          },
          {
            label: "职务信息",
            prop: "manager.duty",
          },
          {
            label: "联系号码",
            prop: "manager.contactInfo",
          },
          
        ],
        firstsblock: {
          formatter: () => {
            return 24;
          },
        },
        sentersblock: {
          formatter: () => {
            return 0;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "35%",
            };
          },
        },
      },
    };
  },

  props: {
    auditState: Boolean,
    bankid: String,
    data: Object,
  },
  components: {
    Accessory,
    Detaillist,
  },
  created() {},

  methods: {
    moment,
    warningblock() {
      this.$emit("warningblock", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.bankdetail_title {
    background: #fff;
    // padding-top: 25px;
    margin-bottom: 25px;
    position: relative;
}
.block_progress {
  margin-top:20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  .progress_title {
    line-height: 45px;
    font-weight: 500;
    font-size: 15px;
    border-radius: 7px 7px 0 0px;
    background: rgb(233, 233, 233);
    text-indent: 15px;
  }
  .stepsblock {
    padding: 25px 15px;
  }
}
.stepsblock .el-step__title.is-process {
  font-weight: 500;
}
.stepsblock .el-step__head.is-process,
.stepsblock .el-step__title.is-process,
.stepsblock .el-step__description.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
  font-weight: 500;
}
.stepsblock .el-step.is-center .el-step__description {
  padding: 0;
}
.stepsblock .el-step__title {
  font-size: 16px;
}
.form_wrapper {
  height: 100%;
  // margin: 0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }}

/deep/.stepsblock .el-step__title {
  font-size: 16px;
}
/deep/ .el-step__title {
  color: #666666;
}
/deep/.el-step__description {
  color: #ccc;
}

</style>

